import { Trans, useTranslation } from 'react-i18next';
import { Box, Center, Flex, SlideFade, Text } from '@chakra-ui/react';
import PageLayout from 'ui/layout/PageLayout';
import Button from 'ui/molecules/Button';
import getEstimateUrl from 'utils/getEstimateUrl';
import { isRenoVendor, isRosselVersion } from 'utils/vendorUtils';
import VideoBlock from 'components/VideoBlock';
import { useNavigate, useLocation } from 'react-router-dom';
import { HOME_ROUTE } from 'config/AppRoutes';
import useAsset, { AssetType } from 'utils/hooks/useAsset';
import { useSelector } from 'react-redux';
import { isB2BSelector } from 'store/selectors';
import { useMemo } from 'react';

const PageThanks = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { search } = useLocation();
  const isB2B = useSelector(isB2BSelector);

  const configID = useMemo(() => {
    const url = new URLSearchParams(search);
    if (url.get('configID')) {
      return url.get('configID');
    }
    if (localStorage?.getItem('lastConfigID')) {
      return localStorage.getItem('lastConfigID');
    }
    return null;
  }, [search]);

  const videoUrl = useAsset(
    AssetType.VIDEO,
    isRenoVendor
      ? `/xx-thanks/HOUSE_HEART-reno-400-500.mp4`
      : `/xx-thanks/HOUSE_HEART-1000-1000.mp4`
  );
  // --------------------- handler ------------------------

  const handleContinue = () => {
    if (configID) {
      const url = getEstimateUrl(configID, false);
      window.location.href = url;
      return;
    }
    navigate(HOME_ROUTE);
  };

  // --------------------- effect ------------------------

  // --------------------- render ------------------------

  return (
    <PageLayout>
      <Flex zIndex={-1} minH="2px" minW="full">
        <VideoBlock
          loop={false}
          mt={{ base: '-20px', md: '-2px' }}
          videoUrl={videoUrl}
          height={{ base: '300px', md: '400px' }}
          transform={{
            base: isB2B ? '' : 'scale(0.9)',
            md: isB2B ? 'scale(1.3) translateY(-20px)' : '',
          }}
        />
      </Flex>
      <Box position="relative" top={{ base: '-50px' }}>
        <SlideFade in offsetY="100px" delay={0.2}>
          <Center
            padding="15px 0px"
            flexDirection="column"
            gap="2em"
            userSelect="none"
          >
            <Text fontSize="2xl" fontWeight="bold">
              {t(`thanks.title${isRosselVersion ? '.rossel' : ''}`)}
            </Text>
            <Text textAlign="center" whiteSpace="pre-line">
              <Trans
                i18nKey={`thanks.description${
                  isRosselVersion ? '.rossel' : ''
                }`}
              >
                before link content
                <a
                  href="/"
                  style={{
                    textDecoration: 'underline',
                    fontWeight: 'bold',
                  }}
                >
                  possible link here
                </a>
                after link content
              </Trans>
            </Text>

            <Button type="submit" onClick={handleContinue}>
              {t('thanks.button')}
            </Button>
          </Center>
        </SlideFade>
      </Box>
    </PageLayout>
  );
};

export default PageThanks;
